<template>

<div>

  <div v-if="animationSrc"  class="imageClass" :style="{right: imagePosition + '%'}" :title="title">
    <v-img
      :src="animationSrc"
      :width="width"
      max-height="400"
      max-width="400"
    ></v-img>
  </div>

  <div v-if="shotEvent" class="spacecraftClass">
    <v-img
      :src="spacecraftImage"
    ></v-img>
  </div>

  <div v-if="shotEvent" class="shotClass" :style="{marginTop: shotPosition + '%'}">
    <v-img
      :src="rocketImage"
    ></v-img>
  </div>

</div>

</template>

<script>

//url
import {ImageUrl} from "@/UrlService.js"

import {QueryGetTodayHoliday} from "@/constants/graphql.js"

export default {

    data: function(){
        return({
            animationSrc: null,
            title: null,
            width: 350,
            imagePosition: 0,
            imageRepetitionCount : 0,
            intervalContainer: null,
            shotEvent: false,
            rocketImage: ImageUrl() + "?filename=rocket.png",
            spacecraftImage: ImageUrl() + "?filename=spacecraft.png",
            shotPosition: 35, //Perc from top of shot
            shotIntervalContainer: null,
        })
    },

    methods: {

      //Every 20ms shift image to left
      startAnimation(){

        this.intervalContainer = window.setInterval(()=>{
        var imagePosition = this.imagePosition + 0.1
        if(imagePosition > 100){
          this.imagePosition = 0
          this.imageRepetitionCount = this.imageRepetitionCount + 1
          }else{
            this.imagePosition = imagePosition
          }
        }, 10);

      }
    },

    watch:{

      //After 2 repetition, set shot event, set x image position and start shoot
      imagePosition(newVal){
        
        if( (newVal > 45) && this.imageRepetitionCount === 1){
          this.shotEvent = true;
          clearInterval(this.intervalContainer);

          //Start shot position shift
          this.shotIntervalContainer = window.setInterval(()=>{
            var shotPosition = this.shotPosition - 0.1;
            if(shotPosition < 10){
              this.animationSrc = null;
              this.shotEvent = false;
            }else{
              this.shotPosition = shotPosition;
            }
          }, 10);
        }
      },

      shotEvent(newVal){
        if(newVal === false){
          clearInterval(this.shotIntervalContainer);
        }
      },

      animationSrc(newVal){
        if(newVal !== null){
          this.startAnimation()
        }
      }
    },

    apollo: {
      //Get image from DB
      animationSrc: {
        query: QueryGetTodayHoliday,
        update: function (data) {
          this.title = data.getTodayHoliday ? data.getTodayHoliday.name : null;
          return data.getTodayHoliday ? data.getTodayHoliday.image : null
        }
      }

    }
}
</script>

<style>

.imageClass{
  margin-top: 2%;
  z-index: 200;
  position: fixed;
}

.spacecraftClass{
  margin-top: 35%;
  z-index: 200;
  position: fixed;
  right: 50%;
  width: 90px;
  height: 80px;
}

.shotClass{
  z-index: 199;
  position: fixed;
  right: 52%;
  width: 40px;
  height: 20px;
}

</style>